import Vue from "vue";
import ModalConfirm from '@/components/common/Modal/Confirm.vue';
import ModalAlert from "@/components/common/Modal/Alert.vue";

export default {

    _base(Component, propsData) {

        const ExtendedComponent = Vue.extend(Component);

        const instance = new ExtendedComponent({
            propsData
        });

        instance.$mount();

        document.body.appendChild(instance.$el);

        return instance;
    },

    async confirm(propsData) {

        const instance = this._base(ModalConfirm, {title: 'Confirmação', ...propsData});

        return new Promise(resolve => {
            instance.$on('change', resolve);
        })
    },

    alert(propsData) {

        const instance = this._base(ModalAlert, propsData);

        return new Promise(resolve => {
            instance.$on('change', resolve);
        })
    }
}



// WEBPACK FOOTER //
// ./src/helpers/wm-modal.js